module.exports = __webpack_public_path__ + "img/catalogue.9ca64b8d.svg";